module.exports = __webpack_public_path__ + "static/media/atmos2.6ffd9d77.jpg";